/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_SubmitInputs */

const vi_sales_return_submit = /** @type {(inputs: Sales_Return_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận trả hàng`)
};

/**

* @param {Sales_Return_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_submit = /** @type {((inputs?: Sales_Return_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_submit(inputs)
});